import { OpportunitySchema } from '@features/opportunities/modules/core/models/schema-property-definition';

export namespace CreditProfile {
  export interface SchemaPropertyDefinition {
    creditScore: OpportunitySchema.NumberPropertyDefinition;
    numberOfEnquiries: OpportunitySchema.NumberPropertyDefinition;
  }

  export interface SchemaContract {
    creditScore?: number | null;
    numberOfEnquiries?: number | null;
  }

  export interface Model {
    creditScore: number | null;
    numberOfEnquiries: number | null;
  }

  export function toSchemaContract(
    model: Partial<Model>
  ): Partial<SchemaContract> {
    return {
      creditScore: model.creditScore ?? null,
      numberOfEnquiries: model.numberOfEnquiries ?? null
    };
  }

  export function toModel(contract: SchemaContract): Model {
    return {
      creditScore: contract.creditScore ?? null,
      numberOfEnquiries: contract.numberOfEnquiries ?? null
    };
  }
}
